import styled from '@emotion/styled';
import { topRoundedCorners } from './RoundedCorners';

const CategoryHeading = styled.h2`
  && {
    margin: 0;
    text-transform: uppercase;
    font-size: ${({ theme }) => theme.sizes.body1};
    color: ${({ theme }) => theme.colors.blackHigh};
    font-family: ${({ theme }) => theme.fonts.secondary};
    display: block;
    ${topRoundedCorners};

    ${({ jobOfTheWeek, theme }) => jobOfTheWeek && `
      && {
        color: #fff;
        background-color: ${theme.colors.primary};
        display: block;
        text-align: center;
        padding: 4px 12px;
      }
    `}
  }
`;

export default CategoryHeading;
